export default function getTooltipInitiation(unit) {
    return {
        visible: false,
        year: null,
        data: [],
        unit: unit,
        x: 0,
        y: 0,
    }
}